import { useLogoutMutation } from '../apis/auth';
import { resetUser } from '../../ducks/userSlice';
import { toast } from 'react-toastify';
import { navigate } from './navigation';

/**
 * Common logout utility function
 * Handles logout API call, clears local storage, and navigates to signin page
 * @param {Object} options - Configuration options
 * @param {string} options.uid - User ID for logout API call
 * @param {Function} options.dispatch - Redux dispatch function (optional)
 * @param {Function} options.navigate - Navigation function (optional)
 * @param {boolean} options.callApi - Whether to call logout API (default: true)
 * @param {boolean} options.clearStorage - Whether to clear localStorage (default: true)
 * @param {boolean} options.navigateToSignin - Whether to navigate to signin (default: true)
 * @param {string} options.signinPath - Path to signin page (default: '/auth/signin')
 */
// export const handleLogout = async (options = {}) => {
//   const {
//     uid,
//     dispatch,
//     navigate,
//     callApi = true,
//     clearStorage = true,
//     navigateToSignin = true,
//     signinPath = '/auth/signin'
//   } = options;

//   try {
//     // Call logout API if uid is provided and callApi is true
//     if (callApi && uid) {
//       // Note: This would need to be called from a component that has access to the mutation hook
//       // For now, we'll just clear the local data
//       console.log('Logout API call would be made here for uid:', uid);
//     }

//     // Clear Redux state if dispatch is provided
//     if (dispatch) {
//       dispatch(resetUser());
//     }

//     // Clear localStorage if enabled
//     if (clearStorage) {
//       localStorage.removeItem("token");
//       localStorage.removeItem("user");
//       // Clear any other user-related data
//       localStorage.removeItem("userInfo");
//     }

//     // Navigate to signin page if enabled
//     if (navigateToSignin) {
//       if (navigate) {
//         navigate(signinPath);
//       } else {
//         // Fallback to window.location if navigate function is not provided
//         window.location.href = signinPath;
//       }
//     }

//     console.log('Logout completed successfully');
//   } catch (error) {
//     console.error('Error during logout:', error);
    
//     // Even if logout API fails, still clear local data
//     if (clearStorage) {
//       localStorage.removeItem("token");
//       localStorage.removeItem("user");
//       localStorage.removeItem("userInfo");
//     }

//     if (navigateToSignin) {
//       if (navigate) {
//         navigate(signinPath);
//       } else {
//         window.location.href = signinPath;
//       }
//     }
//   }
// };

/**
 * Hook for logout functionality with API call
 * Use this in React components that need logout functionality
 */
export const useLogout = () => {
  const [logoutMutation] = useLogoutMutation();

  const logout = async (options = {}) => {
    const {
      uid,
      dispatch,
      navigate,
      clearStorage = true,
      navigateToSignin = true,
      signinPath = '/auth/signin'
    } = options;

    try {
      // Call logout API if uid is provided
      if (uid) {
        await logoutMutation({ uid }).unwrap();
      }

      // Clear Redux state if dispatch is provided
      if (dispatch) {
        dispatch(resetUser());
      }

      // Clear localStorage if enabled
      if (clearStorage) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("userInfo");
      }

      // Navigate to signin page if enabled
      if (navigateToSignin) {
        if (navigate) {
          navigate(signinPath);
        } else {
          window.location.href = signinPath;
        }
      }
      
    } catch (error) {
      console.error('Error during logout:', error);
      
      // Even if logout API fails, still clear local data
      if (clearStorage) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("userInfo");
      }

      if (navigateToSignin) {
        if (navigate) {
          navigate(signinPath);
        } else {
          window.location.href = signinPath;
        }
      }
    }
  };

  return { logout };
};

/**
 * Simple logout function for token expiration scenarios
 * This doesn't require React hooks and can be used in API interceptors
 * @param {string} uid - User ID for logout API call (optional)
 */
export const simpleLogout = async (uid = null) => {
  //   const {
  //   navigate,
  // } = options;
  try {
    // Call logout API if uid is provided
    if (uid) {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/v1/auth/logout/${uid}`, {
          method: 'PATCH',
          headers: {
            'Content-type': 'application/json',
            'authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });
        
      } catch (apiError) {
        console.warn('Logout API call error:', apiError);
        // Continue with local logout even if API fails
      }
    }

    // Clear localStorage
    // localStorage.removeItem("token");
    // localStorage.removeItem("user");
    // localStorage.removeItem("userInfo");
    localStorage.clear()
    
    // Navigate to signin page
    // window.location.href = '/auth/signin';
    navigate('/auth/signin');
    toast.success('Token expired')
  } catch (error) {
    console.error('Error during simple logout:', error);
    // Force navigation even if there's an error
    // window.location.href = '/auth/signin';
     navigate('/auth/signin');
     localStorage.clear()
    toast.success('Token expired')
  }
};
